import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { IPayments } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { MenuModule } from "primeng/menu";
import { TableModule } from "primeng/table";
import { CommonComponent } from "../../../../../../lib/components/common/common.component.mjs";

@Component({
  selector: "app-payments-card",
  standalone: true,
  imports: [CommonModule, BlockUIModule, CardModule, TableModule, ButtonModule, MenuModule],
  templateUrl: "./payment-card.component.html",
  styleUrls: ["./payment-card.component.scss"],
})
export class PaymentCardComponents extends CommonComponent {
  @Input()
  payments: IPayments[] = [];

  constructor(protected router: Router) {
    super();
  }

  selectedPayment: IPayments | undefined;

  items: MenuItem[] = [
    {
      label: 'View',
      icon: 'pi pi-file',
      command: () => this.view(this.selectedPayment!.id),
    },
    {
      label: 'View in Stripe',
      icon: 'pi pi-file',
      command: () => this.viewInStripe(this.selectedPayment!.integration_reference),
    }
  ];

  view(payment_id: string) {
    this.router.navigate(['/admin/payments/view/', payment_id]);
  }
  
  viewInStripe(payment_id: string) {
    window.open('https://dashboard.stripe.com/payments/' + payment_id, '_blank');
  }
}
